import { render } from "./BuildingAccessCardView.vue?vue&type=template&id=9232291a&scoped=true"
import script from "./BuildingAccessCardView.vue?vue&type=script&lang=js"
export * from "./BuildingAccessCardView.vue?vue&type=script&lang=js"

import "./BuildingAccessCardView.vue?vue&type=style&index=0&id=9232291a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9232291a"]])

export default __exports__